var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.3335C8.27614 5.3335 8.5 5.55735 8.5 5.8335V8.50016C8.5 8.7763 8.27614 9.00016 8 9.00016C7.72386 9.00016 7.5 8.7763 7.5 8.50016V5.8335C7.5 5.55735 7.72386 5.3335 8 5.3335Z",
    fill: "url(#paint0_linear_668_16052)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1668C8.36819 11.1668 8.66667 10.8684 8.66667 10.5002C8.66667 10.132 8.36819 9.8335 8 9.8335C7.63181 9.8335 7.33333 10.132 7.33333 10.5002C7.33333 10.8684 7.63181 11.1668 8 11.1668Z",
    fill: "url(#paint1_linear_668_16052)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81559 1.86757C6.77821 1.53788 7.37498 1.3335 8 1.3335C8.62502 1.3335 9.22179 1.53789 10.1844 1.86757L10.6694 2.03358C11.6569 2.37163 12.4191 2.63251 12.9646 2.85415C13.2395 2.9658 13.4758 3.07394 13.666 3.18443C13.8491 3.29077 14.0328 3.42339 14.1576 3.60119C14.2809 3.77694 14.3447 3.99299 14.3848 4.20098C14.4265 4.4172 14.4516 4.67659 14.4678 4.9744C14.5 5.56576 14.5 6.3759 14.5 7.42671V8.4944C14.5 12.5618 11.428 14.5118 9.60111 15.3099L9.58304 15.3178C9.35652 15.4167 9.14358 15.5098 8.89893 15.5724C8.64062 15.6385 8.36617 15.6668 8 15.6668C7.63383 15.6668 7.35938 15.6385 7.10107 15.5724C6.85641 15.5098 6.64348 15.4167 6.41695 15.3178L6.39889 15.3099C4.57202 14.5118 1.5 12.5618 1.5 8.4944V7.42676C1.5 6.37594 1.5 5.56577 1.5322 4.9744C1.54842 4.67659 1.57354 4.4172 1.61521 4.20098C1.65529 3.99299 1.71907 3.77694 1.84242 3.60119C1.96721 3.42339 2.1509 3.29077 2.33399 3.18443C2.52424 3.07394 2.76052 2.9658 3.03535 2.85415C3.58094 2.63251 4.34308 2.37163 5.33063 2.03359L5.81559 1.86757ZM8 2.3335C7.56151 2.3335 7.1301 2.47459 6.05374 2.84303L5.67187 2.97374C4.66347 3.31892 3.92807 3.57086 3.41173 3.78062C3.154 3.88532 2.96727 3.97306 2.83619 4.04918C2.77148 4.08676 2.72689 4.11777 2.69711 4.14198C2.67186 4.1625 2.66224 4.17413 2.66086 4.17582C2.65957 4.17791 2.65129 4.19177 2.63962 4.22452C2.6263 4.26193 2.61153 4.31555 2.59714 4.3902C2.56803 4.54129 2.54596 4.74884 2.53072 5.02877C2.50018 5.58957 2.5 6.37238 2.5 7.4446V8.4944C2.5 11.9445 5.07993 13.6425 6.79919 14.3935C7.04684 14.5017 7.18986 14.5629 7.34907 14.6037C7.50112 14.6426 7.68667 14.6668 8 14.6668C8.31333 14.6668 8.49888 14.6426 8.65093 14.6037C8.81014 14.5629 8.95316 14.5017 9.20081 14.3935C10.9201 13.6425 13.5 11.9445 13.5 8.4944V7.4446C13.5 6.37238 13.4998 5.58957 13.4693 5.02877C13.454 4.74884 13.432 4.54129 13.4029 4.3902C13.3885 4.31555 13.3737 4.26193 13.3604 4.22452C13.3487 4.19174 13.3404 4.17789 13.3391 4.17582C13.3377 4.17411 13.3281 4.16249 13.3029 4.14198C13.2731 4.11777 13.2285 4.08676 13.1638 4.04918C13.0327 3.97306 12.846 3.88532 12.5883 3.78062C12.0719 3.57086 11.3365 3.31892 10.3281 2.97374L9.94626 2.84303C8.8699 2.47459 8.43849 2.3335 8 2.3335Z",
    fill: "url(#paint2_linear_668_16052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_16052",
    x1: 8,
    y1: 1.3335,
    x2: 8,
    y2: 15.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_16052",
    x1: 8,
    y1: 1.3335,
    x2: 8,
    y2: 15.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_16052",
    x1: 8,
    y1: 1.3335,
    x2: 8,
    y2: 15.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldWarning);
export default __webpack_public_path__ + "static/media/ShieldWarning.9b123ad434751c9c4dfeef5a00ab8e23.svg";
export { ForwardRef as ReactComponent };